import { Outlet, useNavigate } from "react-router-dom";
import Topbar from "../components/Topbar";
import { clearSession, loadSession } from "../auth";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export default function AppLayout({ hideNav = false, childrenOverride = null }) {
  const session = loadSession();
  const nav = useNavigate();
  async function handleLogout() {
    try {
      await fetch(`${API_URL}/auth/logout`, { method: "POST", credentials: "include" });
    } catch {
      // backend unreachable; still clear local session and redirect
    }
    clearSession();
    nav("/login", { replace: true });
  }
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Topbar user={session?.user} onLogout={handleLogout} hideNav={hideNav} />
      <main className="max-w-6xl mx-auto px-4 py-8">
        {childrenOverride ? childrenOverride : <Outlet />}
      </main>
    </div>
  );
}
